import $ from 'jquery';
import 'slick-carousel';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const initCarousel = () => {
	$('[data-component="carousel"]').each(function () {
		$(this).slick({
			prevArrow: '<span class="carousel__prev"></span>',
			nextArrow: '<span class="carousel__next"></span>',
			dots: true,
			dotsClass: 'carousel__pager',
			slidesToShow: 3,
			infinite: true,
			responsive: [
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});
};

export default initCarousel;